// "Found the right part?" (2026-10-30, docs/agent-draft-shadow.md "Fitment
// before a purchase"). Pure helpers for the box under What's next on a
// fitment_preorder draft whose "don't carry" is not sure (the agent's
// "Double-check we don't carry ..." line), or the pipeline's Do / Don't
// Carry with no part. The server resolves the part
// (POST /api/ai/suggestions/:id/correct-part).

export const DOUBLE_CHECK_RE = /^Double-check we don't carry\b/
export const BOX_LABEL = 'Found the right part? Paste the part number or link'

// Whether the box shows: a fitment question before a purchase, and the
// agent's unsure "don't carry" line, or a Do / Don't Carry template with no
// part yet.
export function correctPartBoxApplies({ intent = null, nextSteps = [], templateTitle = null, reply = '' } = {}) {
  if (intent && intent !== 'fitment_preorder') return false
  if ((nextSteps ?? []).some((s) => DOUBLE_CHECK_RE.test(String(s ?? '').trim()))) return true
  if (!intent) return false
  if (/prefit no do(?:n['’]?t)? carry/i.test(String(templateTitle ?? ''))) return true
  return /\bINSERTLINK\b/.test(String(reply ?? '')) && /we do carry the correct part/i.test(String(reply ?? ''))
}

// What's next once the CSR's part is used: the "Double-check" line goes;
// the server's own lines for it (a link to fill in, an unconfirmed fitment)
// are added.
export function stepsAfterCorrectPart(steps = [], extra = []) {
  const kept = (steps ?? []).filter((s) => !DOUBLE_CHECK_RE.test(String(s ?? '').trim()))
  return [...kept, ...(extra ?? []).filter((s) => !kept.includes(s))]
}

// The confidence once the part is used: the unsure "don't carry" reason
// goes; with no reason left, it is High.
export function confidenceAfterCorrectPart(confidence) {
  if (!confidence?.level) return confidence ?? null
  const reasons = (confidence.reasons ?? []).filter((r) => !/Don't Carry not confirmed/i.test(String(r)))
  if (reasons.length === (confidence.reasons ?? []).length) return confidence
  return { ...confidence, level: reasons.length ? confidence.level : 'high', reasons }
}

// The box's line for a result that changes nothing (or why it asks).
export function resultLine(result) {
  if (!result) return null
  if (result.status === 'fits' || result.status === 'fits_unconfirmed') return null
  return result.message ?? 'No part found.'
}
